import React, { ReactNode } from 'react';
import { Auth0Provider as Auth0ProviderOriginal } from '@auth0/auth0-react';

interface Auth0ProviderProps {
  children: ReactNode;
}

const Auth0Provider: React.FC<Auth0ProviderProps> = ({ children }) => {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN || '';
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID || '';
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE || '';
  const redirectUri = window.location.origin;

  // Log Auth0 configuration for debugging
  console.log('Auth0 Configuration:', {
    domain,
    clientId: clientId ? '[REDACTED]' : 'Not set',
    audience,
    redirectUri
  });

  if (!domain || !clientId) {
    console.warn('Auth0 domain or clientId not set, skipping Auth0 initialization');
    return <>{children}</>;
  }

  return (
    <Auth0ProviderOriginal
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        scope: 'openid profile email offline_access',
      }}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0ProviderOriginal>
  );
};

export default Auth0Provider;